import { createDomain, sample } from 'effector'
import { FormValues } from '~/entities/common/Taxipark/Subdivisions/model'
import { AxiosErrorType, Subdivision } from '~/shared/api'
import { backFx } from '~/shared/lib/history'
import { logger } from '~/shared/lib/logger'
import { mapMessageErrors } from '~/shared/lib/mapMessageErrors'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { isString } from '~/shared/lib/utils'

export const domain = createDomain('features.taxipark.subdivision.add')

export const createFx = domain.createEffect<
  FormValues,
  Subdivision,
  AxiosErrorType
>({
  async handler(values) {
    const { regionId, ...attr } = values
    const subdivision = new Subdivision(attr)

    if (isString(regionId)) subdivision.setRegion(regionId)

    const result = await subdivision.save()
    return result.getModel() as Subdivision
  },
})

export const formSubmitted = domain.createEvent<FormValues>()
sample({
  clock: formSubmitted,
  target: createFx,
})

sample({
  clock: createFx.doneData,
  fn() {
    return {
      messageI18n: 'alert.department created successfully' as const,
      variant: 'success' as const,
    }
  },
  target: [snackbarEnqueued, backFx],
})

sample({
  clock: createFx.failData,
  fn(e) {
    logger.error(e)
    return {
      message: mapMessageErrors(e),
      variant: 'error' as const,
    }
  },
  target: snackbarEnqueued,
})
